import Entity from '../entity'
import UserProductAppointment from './UserProductAppointment';

export default class ProductAppointmentOption extends Entity<number>{
    productId: number = null;
    // tenantId: number = null;
    appointmentOptionId: number = null;
    // creationTime: string;
    // remark: string  = null;
    // userProductAppointments: Array<UserProductAppointment>;

}